<template>
	<div style="margin: 10px;" v-loading="loading">
		<el-row>
			<el-col :spa="24">
				<el-card class="box-card">
					<h4 class="title">表单参数信息</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">
						<el-form-item label="栏目名称" prop="column">
							<el-input v-model="form.cid" style="width: 30%;" placeholder="添加栏目名称" @click.native="getColumn" readonly></el-input>
						</el-form-item>
						<el-form-item label="表单名称" prop="formName">
							<el-input v-model="form.formName" style="width:30%"></el-input>
						</el-form-item>
						<el-form-item label="表单标题" >
							<el-input v-model="form.formTitle" style="width:30%"></el-input>
						</el-form-item>
						<el-form-item label="表单副标题" >
							<el-input v-model="form.subtitle" style="width:30%" rows="3"></el-input>
						</el-form-item>
                        <el-form-item label="表单背景图">
							<el-upload drag  list-type="picture-card"  action="" multiple :limit="1" :on-success="getLogo" :file-list="logoList"
							 :on-remove="RemoveLogo" :on-exceed="handleLogo" :before-upload="beforePic" style="width:auto;float: left;">
								<i class="el-icon-picture-outline"></i>
								<br />
								<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<input type="button" size="mini" class="bullet" style="display: inline-block;float: left;" @click.stop="dialogVisible = true"
							 value="素材库选择">
							<!-- <img :src="settings.apiBaseImg+form.pic" alt="" v-if="form.pic"  style="width: 200px;height: 200px;margin-top: 10px;"> -->
						</el-form-item>
                        <el-form-item>
							<input type="button" @click="onSubmit('form')" class="submit" value="提交">
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
		<!-- 素材库选择 -->
		<el-dialog title="素材库选择" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<files @selectPic="selectPic"></files>
		</el-dialog>
		<el-dialog title="栏目选择" :visible.sync="dialogColumnVisible" width="50%" :before-close="handleClose">
			<span class="select">您已选择:{{form.column}}</span>
			<el-tree :data="data" show-checkbox node-key="id" :props="defaultProps" :default-checked-keys="selectCId" ref="tree"
			 @check="handleNodeClick">
			</el-tree>
		</el-dialog>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	import files from '../../../components/picFile.vue'
	export default {
		components: {
			files
		},
		data() {
			return {
				form: {
					//名称
					formName: '',
					//标题
					formTitle: '',
					//栏目
					column: [],
					bg: '',
					bgThumb: '',
					cid: '',
                    // 副标题
					subtitle:'',
                    id:'',
				},
				rules: {
					formName: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					column: [{
						required: true,
						message: '请输入栏目',
						trigger: 'blur'
					}],
				},
				dialogVisible: false,
				logoList: [],
				tableData: [],
				currentPage: 1,
				pageSize: 5,
				total: 0,
				loading: false,
				data: [],
				dialogColumnVisible: false,
				defaultProps: {
					children: 'childRpColum',
					label: 'columname'
				},
				loading: false,
				selectCId: [],
                editCheckId:'',

			}
		},
		created() {
			if (this.$route.query.iden == 'update') {
				var list = JSON.stringify(this.$route.query.rows)
				this.form.formName = this.$route.query.rows.formName
				this.form.formTitle = this.$route.query.rows.formTitle
				this.form.bg = this.$route.query.rows.fromImage
				this.form.cid = this.$route.query.rows.cid
                this.form.id = this.$route.query.rows.id
				this.form.subtitle = this.$route.query.rows.formSubTitle
				this.logoList.push({url:this.settings.apiBaseImg+this.$route.query.rows.formImage})
			}
		},
		methods: {

			//获取栏目
			getColumn() {
				this.dialogColumnVisible = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/column/list',
					params: {
						uid: localStorage.getItem('uid')
					},
				}).then((res) => {
					if (res.status == 200) {
						this.data=res.data.data
						this.data.push({
							id:0,
							columname:'首页'
						})
					} else {
						obj.$message.error(res.data.msg)
					}
				})
			},
			//选择栏目
			handleNodeClick() {
				this.selectCId = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
				var arr = []
				for (var i = 0; i < this.$refs.tree.getCheckedNodes().length; i++) {
                    this.form.cid = this.$refs.tree.getCheckedNodes()[i].id
					arr.push(this.$refs.tree.getCheckedNodes()[i].columname)
				}
				this.form.column = arr.join(',')
			},
            // 单选栏目
            // checkChange(item,node,self){
            //     if(node==true){
            //         this.editCheckId = item.id;
            //         this.$ref.tree.setCheckedKeys([item.id])
            //         // this.form.column = this.$ref.tree.getCurrentNode()
            //         console.log(this.$refs.tree.getCheckedNodes())
            //     }else{
            //         if(this.editCheckId === item.id){
            //             this.$refs.tree.setCheckedKeys([item.id])
            //         }
            //     }
            // },
            // nodeClick(item,node,self){
            //     this.editCheckId = item.id;
            //     this.$refs.tree.setCheckedKeys([item.id])
            // },
			//提价
			onSubmit(formName) {
				if (this.$route.query.iden == 'add') {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							var obj = this;
							obj.$http({
								method: 'post',
								url: '/api/v1/form/add',
								data: {
                                    cid:this.form.cid,
                                    formName:this.form.formName,
                                    formTitle:this.form.formTitle,
                                    formSubTitle:this.form.subtitle,
                                    formImage:this.form.bg,
								},
							}).then((res) => {
								if (res.data.status == 200) {
									this.$message.success('添加成功！');
									this.$router.push({
										path: '/home/formManage'
									})
								} else {
									this.$message.error(res.data.message);
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});

				} else {
					this.onUpdate()
				}
			},
			//上传图片之前调取接口
			beforePic(file, fileList) {
				this.loading = true
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: '/api/v1/form/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
                        console.log(res,'表单背景图')
						this.form.bg = res.data.data.images
						this.form.bgThumb = res.data.data.imagesThumb
						this.logoList=[]
						this.logoList.push({url:this.settings.apiBaseImg+res.data.data.imagesThumb})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//修改
			onUpdate() {
				console.log(this.form)
				var obj = this;
				obj.$http({
					method: 'post',
					url: '/api/v1/form/update',
					data: {
						id:this.form.id,
						cid:this.form.cid,
                        formName:this.form.formName,
                        formTitle:this.form.formTitle,
                        formSubTitle:this.form.subtitle,
                        formImage:this.form.bg,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.$message.success('修改成功！');
						this.$router.push({
							path: '/home/formManage'
						})
					} else {
						this.$message.error(res.data.message);
					}
				})
			},
			//关闭弹窗
			handleClose(done) {
				done();
			},
			//上传图片成功
			getLogo(file, fileList) {
				this.form.pic = file.data.images
				this.form.picThumb = file.data.imagesThumb
			},
			//删除图片
			RemoveLogo() {
				this.form.pic = ''
			},
			//图片限制
			handleLogo(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			//素材库选择图片
			selectPic(index, rows) {
				this.logoList=[]
				this.logoList.push({url:this.settings.apiBaseImg+ rows.path})
				this.form.pic = rows.path
				this.dialogVisible = false
			},

		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 40px;
	}

	/deep/ .el-input__inner {
		height: 30px;
	}

	.picTip {

		height: 16px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.5;
		margin-left: 10px;
	}

	.selectC {
		display: inline-block;

	}

	.selectC span {
		display: inline-block;
	}

	.selectC ul li {
		list-style: none;
		display: inline-block;
	}

	.select {
		font-size: 16px;
		font-weight: bold;
		display: block;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/form/formAdd.vue